export default "__VITE_ASSET__19e2ae02__"